import {Log} from '@aboutyou/mlm';
import {WINDOW_SERVER_COOKIES} from '@aboutyou/storage';

import {assert} from 'ts-essentials';

export async function initializeServerCookies() {
  assert(
    process.browser,
    'Expected initializeServerCookies to be called on the client only',
  );

  if (WINDOW_SERVER_COOKIES in globalThis) {
    // Already initialized, do nothing
    return;
  }

  const serverCookies = getServerCookies(document.body);

  assert(
    serverCookies,
    "Expected server cookies to be available in the client's initial markup. " +
      'Make sure it is provided via the server rendering code and that it is valid JSON.',
  );

  window.__SERVER_COOKIES__ = serverCookies;
}

function getServerCookies(container: Element) {
  const serverCookie = container.querySelector('[data-server-cookie-markup]');

  if (!serverCookie) {
    return {};
  }

  try {
    return JSON.parse(serverCookie.innerHTML);
  } catch (error) {
    Log.error('@aboutyou/bootstrap', `Error parsing server cookies:`, {error});

    return {}; // Return an empty object if parsing fails, returning nullish values can lead to the page not being hydrated at all.
  }
}

export function getServerCookiesOnClient(): Record<string, string> {
  const serverCookies = window[WINDOW_SERVER_COOKIES];

  return serverCookies ?? {};
}
